import { configureStore } from '@reduxjs/toolkit'

import authReducer from './slices/AuthSlice'


const rootReducer = {
    auth: authReducer,
}

export default configureStore({
    reducer: rootReducer
})